import {MouseEvent} from 'react';

import {openExternalWebview} from '@zzng/common/scheme/web';
import {TrackInterface} from '@zzng/common/utils/tiara';

import Space from '@/shared/components/Space';
import {TIARA_ACTION} from '@/shared/constants/tiara';
import {KAKAO_CORP_URL} from '@/shared/constants/url';

type Props = {
  trackEvent: (tiara: TrackInterface) => void;
};

const SimpleFooter = ({trackEvent}: Props) => {
  const onClickLink = (url: string) => (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    trackEvent({action: TIARA_ACTION.KAKAO_CLICK});

    if (window.digitalCard) {
      openExternalWebview(url, {isCurrentWebviewClose: false});
    } else {
      window.open(url, '_blank');
    }
  };

  return (
    <footer id="kakaoFoot" className="footer_comm">
      <h2 className="screen_out">서비스 이용정보</h2>
      <small className="txt_copyright">
        Copyright © <Space />
        <a href="#none" className="link_kakao" onClick={onClickLink(KAKAO_CORP_URL)}>
          Kakao Corp. <Space />
        </a>
        All rights reserved.
      </small>
    </footer>
  );
};

export default SimpleFooter;
